// Module
var code = "<label ng-class=\"{disabled: ctrl.disabled}\" ng-click=\"!ctrl.disabled && ctrl.onClick()\"> <span class=\"image checked\" ng-show=\"ctrl.model\" ng-include=\"ctrl.checkedIcon\"></span> <span class=\"image unchecked\" ng-hide=\"ctrl.model\" ng-include=\"ctrl.uncheckedIcon\"></span> <span class=\"content\" ng-transclude></span> </label>";
// Exports
module.exports = code;